import axios from 'axios';
import { Language } from '../translations';

const ELEVENLABS_API_URL = 'https://api.elevenlabs.io/v1';

const VOICE_IDS = {
  nl: {
    male: 's7Z6uboUuE4Nd8Q2nye6',
    female: 'gC9jy9VUxaXAswovchvQ'
  },
  en: {
    male: 'VR6AewLTigWG4xSOukaG',
    female: 'SXBL9NbvTrjsJQYay2kT'
  },
  tr: {
    male: 'ErXwobaYiN019PkySvjV',
    female: 'ThT5KcBeYPX3keUQqHPh'
  }
};

function splitLongText(text: string, maxLength: number = 500): string[] {
  const parts: string[] = [];
  let currentPart = '';
  
  text.split('. ').forEach(sentence => {
    if ((currentPart + sentence).length > maxLength) {
      parts.push(currentPart.trim());
      currentPart = sentence;
    } else {
      currentPart += sentence + '. ';
    }
  });
  
  if (currentPart) parts.push(currentPart.trim());
  return parts;
}

export async function generateVoiceAudio(script: string, language: Language): Promise<string> {
  try {
    const lines = script.split('\n').filter(line => line.trim());
    const audioBlobs: Blob[] = [];

    for (const line of lines) {
      const [speaker, text] = line.split(':');
      if (!speaker || !text) continue;

      const isMale = speaker.trim().toLowerCase() === 'tom' || 
                    speaker.trim().toLowerCase() === 'jack' || 
                    speaker.trim().toLowerCase() === 'ahmet';

      const voiceId = VOICE_IDS[language][isMale ? 'male' : 'female'];
      const textParts = splitLongText(text.trim());

      for (const part of textParts) {
        const response = await axios({
          method: 'post',
          url: `${ELEVENLABS_API_URL}/text-to-speech/${voiceId}`,
          headers: {
            'Accept': 'audio/mpeg',
            'Content-Type': 'application/json',
            'xi-api-key': import.meta.env.VITE_ELEVENLABS_API_KEY
          },
          data: {
            text: part,
            model_id: 'eleven_multilingual_v2',
            voice_settings: {
              stability: 0.7,
              similarity_boost: 0.85,
              style: 0.7,
              use_speaker_boost: true
            }
          },
          responseType: 'blob'
        });

        if (response.data instanceof Blob) {
          audioBlobs.push(response.data);
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
    }

    if (audioBlobs.length === 0) {
      throw new Error('No audio segments generated');
    }

    const combinedBlob = new Blob(audioBlobs, { type: 'audio/mpeg' });
    return URL.createObjectURL(combinedBlob);
  } catch (error: any) {
    throw new Error(`Audio generation failed: ${error.message}`);
  }
}